import { Component } from '@angular/core';
import { TubeCharacteristicsAddEditComponent } from './tube-characteristics-add-edit/tube-characteristics-add-edit.component';
import { Subject, takeUntil } from 'rxjs';
import { ITubeCharacteristicsDetailed } from 'src/app/interfaces/TubeCharacteristics/ITubeCharacteristicsDetailed';
import { TubeCharacteristicsService } from 'src/app/services/tubeCharacteristics.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { COLORS } from 'src/styles/colors';
import { SwalToastService } from 'src/app/services/swal.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-tube-characteristics',
    templateUrl: './tube-characteristics.component.html',
    styleUrls: ['./tube-characteristics.component.css'],
    standalone: false
})
export class TubeCharacteristicsComponent {
  public addComp = TubeCharacteristicsAddEditComponent;

  private destroy$ = new Subject<void>();

  tubeCharacteristics?: ITubeCharacteristicsDetailed[];
  isLoading: boolean = false;

  constructor(
    private readonly tubeCharacteristicsService: TubeCharacteristicsService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  openModalFun(item?: ITubeCharacteristicsDetailed) {
    this.tubeCharacteristicsService.tubeCharacteristicsModalSub.next(true);
    this.tubeCharacteristicsService.tubeCharacteristicsEditSub.next(item);
  }

  deleteFun(id: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder2'
      )} ${this.translate.instant('Tube Characteristic')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.tubeCharacteristicsService
          .deleteTubeCharacteristics(id.toString())
          .subscribe({
            next: (d) => {
              this.swalToastService.toastSuccess(
                'Tube Characteristics record deleted successfully'
              );
              this.tubeCharacteristicsService.deleteTubeCharacteristicsFromTable(
                id.toString()
              );
            },
            error: (err) => {
              this.swalToastService.toastError(
                'Unable to delete Tube Characteristics record'
              );
            },
          });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant(
            'Tube Characteristics record is not deleted'
          )}`,
          '',
          'info'
        );
      }
    });
  }
  ngOnInit() {
    this.tubeCharacteristicsService.tubeCharacteristicsLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.tubeCharacteristicsService.tubeCharacteristicsDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: ITubeCharacteristicsDetailed[]) => {
        this.tubeCharacteristics = data;
      });

    this.tubeCharacteristicsService.getData();
  }
}
